import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import css from './SectionCurrently.module.css';

import bg3 from '../images/bg3-cropped.jpg';

const SectionCurrently = props => {
  const { rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <div className={css.sectionLeft} />

      <div className={css.sectionRight}>
        <p>
          CURRENTLY
          <br />
          ON ROTATION
        </p>
        <NamedLink name="SearchPage" className={css.heroLeftButton}>
          SHOP
        </NamedLink>
      </div>
    </div>
  );
};

SectionCurrently.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

SectionCurrently.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionCurrently;
